export default __webpack_public_path__ + "static/media/file-searching-entrance.28386b37.gif";